import { useState, useEffect, useRef, useContext, useCallback } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ServiceContext } from "../../../contexts/ServiceContext";
import { AppAlert } from "../../../utils/AppAlert";
import { ReactComponent as WebsiteIcon } from "../../../icons/website.svg";
import { ReactComponent as AlarmIcon } from "../../../icons/alarm.svg";
import { ReactComponent as EmailIcon } from "../../../icons/email.svg";
import { ReactComponent as EditIcon } from "../../../icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../icons/delete.svg";
import { ReactComponent as DevicesIcon } from "../../../icons/devices.svg";
import { ReactComponent as UsersIcon } from "../../../icons/users.svg";
import { ReactComponent as MenuIcon } from "../../../icons/menu.svg";
import { ReactComponent as EmailsMenuIcon } from "../../../icons/email-menu.svg";
import { ReactComponent as DevicesMenuIcon } from "../../../icons/devices-menu.svg";
import { ReactComponent as UsersMenuIcon } from "../../../icons/users-menu.svg";
import { ReactComponent as CompaniesMenuIcon } from "../../../icons/company-menu.svg";
import { ReactComponent as MessagesMenuIcon } from "../../../icons/messages-menu.svg";
import { ReactComponent as PhoneNumberMenuIcon } from "../../../icons/phone-number-menu.svg";
import config from "../../../config";
import "./companies.css";

function Companies() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [menu, setMenu] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(0);
  const menuRef = useRef(null);
  const {infrastructureService } = useContext(ServiceContext);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [availableCompanies, setAvailableCompanies] = useState("");
  const [availableUsers, setAvailableUsers] = useState("");
  const [availableDevices, setAvailableDevices] = useState("");
  const [emailNotifications, setAvailableEmailNotifications] = useState("");
  const [messagesNotifications, setAvailablemMssagesNotifications] = useState("");
  const [phoneCallsNotifications, setAvailablePhoneCallsNotifications] = useState("");
  const [filter, setFilter] = useState(searchParams.get("filter") || "");
  const [showBlocked, setShowBlocked] = useState((searchParams.get("showBlocked")=== "true") || false); 
  const [currentPage, setCurrentPage] = useState(Number(searchParams.get("currentPage")) || 1);
  const [totalPages, setTotalPages] = useState(1);
  const userRole = localStorage.getItem("user_role");
  const Global_Admin_Role = "Global Admin";
  let updatedIds;
  const itemsPerPage = config.uiSettings.itemsPerPage || 20;

  const navigate = useNavigate();

 const handleLeftClick = (e, id) => {
    e.stopPropagation();

    const clickX = e.clientX;
    const clickY = e.clientY;
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;

    const menuW = 120; 
    const menuH = menuRef.current ? menuRef.current.offsetHeight : 120;

    let posX = clickX;
    let posY = clickY;
    
    if (clickX + menuW > screenW) {
      posX = screenW - menuW - 5;
    }
    
    if (clickY + menuH > screenH) {
      posY = screenH - menuH - 5;
    }

    setMenu({ x: posX, y: posY, id });
  };  
  
  const handlePageChange = (p) => {
    setCurrentPage(p);
    setSearchParams({ids: (updatedIds || []).join(","), showBlocked: showBlocked, filter: filter, currentPage: p});
  };

  const handleChange = (e) => {
    setCurrentPage(1);
    setFilter(e.target.value);
  };

  const handleBlur = (e) => {
    setSearchParams({ids: (updatedIds || []).join(","), showBlocked: showBlocked, filter: e.target.value, currentPage: 1});
  };

  const handleShowBlockedChange = (e) => {
    setCurrentPage(1);
    setShowBlocked(e.target.checked);
    setSearchParams({ids: (updatedIds || []).join(","), showBlocked: e.target.checked, filter: filter, currentPage: 1});
  };

  const handleClick = () => setMenu(null);

  useEffect(() => {
    const newFilter = searchParams.get("filter") || "";
    const newShowBlocked = searchParams.get("showBlocked") === "true";
    const newCurrentPage = Number(searchParams.get("currentPage")) || 1;
    setFilter(newFilter);
    setShowBlocked(newShowBlocked);
    setCurrentPage(newCurrentPage);
    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, [searchParams]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
         menuRef.current &&
         !menuRef.current.contains(e.target) &&
         !e.target.closest(".menu-trigger") 
        ) {
          setMenu(null);
        }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  
  function Card({id, name, email, site, activeAlarmCount, availableDevices, availableUsers }) {

      const [openExpanderCard, setOpenExpanderCard] = useState(false);
      
      useEffect(() => {
         const idsFromUrl = (searchParams.get("ids") || "").split(",").filter(Boolean).map(Number);
         setOpenExpanderCard(idsFromUrl.includes(id));
      }, [id]);
     
      const toggleCard = () => {
        const idsFromUrl = (searchParams.get("ids") || "").split(",").filter(Boolean).map(Number);       
        if (idsFromUrl.includes(id)) {
          updatedIds = idsFromUrl.filter(i => i !== id);
        } else {
           updatedIds = [...idsFromUrl, id];
          }
          setSearchParams({ ...Object.fromEntries(searchParams.entries()), ids: (updatedIds || []).join(","), showBlocked: showBlocked, filter: filter, currentPage: currentPage });
      };

  return (
    <div className="card-border">
      <div className="card-div" onClick={toggleCard} >
        <div className="div-inline-50">
          {name}
        </div>
        <div className="div-inline-20">
           <Link to={`/users?ids=&companyId=${id}&filter=`} onClick={(e)=>e.stopPropagation()}>
            <label className="link-lab"> 
             <UsersIcon/><span> {availableUsers} {availableUsers === 1 ? "user" : "users"}</span>
            </label>
          </Link>
        </div>
        <div className="div-inline-20">
          <Link to={`/devices?ids=&companyId=${id}&filter=`} onClick={(e)=>e.stopPropagation()}>
           <label className="link-lab"> 
            <DevicesIcon/><span> {availableDevices} {availableDevices === 1 ? "device" : "devices"}</span>
           </label>
          </Link>
        </div>
        <div className="div-inline-3" style={{minWidth: "55px"}}>
           {activeAlarmCount !== undefined && activeAlarmCount !== 0 && (<label>
              <AlarmIcon/><span>{activeAlarmCount}</span>
            </label>)}
        </div>
        <div className="div-inline-3">
          <svg  width="20" height="20" fill="currentColor" viewBox="0 0 16 16" onClick={(e) => handleLeftClick(e, id)}>
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
          </svg>
          {menu && menu.id === id && (
            <ul ref={menuRef} className="context-menu" style={{ top: menu.y, left: menu.x, position: "fixed" }}>
              <li onClick={(e) => {  e.stopPropagation(); navigateToCompanySettingsClick(id);}}>
                <label>
                  <EditIcon/> Edit
                </label>
              </li>
              <li>
                <label onClick={(e) => {  e.stopPropagation(); setSelectedItemId(id); deleteCompanyClick(); setMenu(null);}}>
                  <DeleteIcon/> Delete
                </label>                
              </li>
            </ul>
          )}
        </div>
        <div className="div-inline-3">
          <div className="open-expander-card">
          {openExpanderCard ? "▲" : "▼"}
        </div>
        </div>
      </div>
      <div className="cerd-div">
        {openExpanderCard && (
           <div className="card-div card-border-text">
              <div className="div-inline-100">
                 <label>
                   <EmailIcon/><span className="span-bold">Email</span><span>: {email}</span>
                 </label><br/>
                 <label>
                   <WebsiteIcon/><span className="span-bold">Website</span><span>: {site}</span>
                 </label>
              </div>
           </div>
        )}
      </div>
      {isOpen && (
        <div style={{position: "fixed",top: 0,left: 0,right: 0,bottom: 0,display: "flex",justifyContent: "center",alignItems: "center",zIndex: 1000,}}> 
            <div style={{backgroundColor: "white",borderRadius: "8px",width: "300px",boxShadow: "0 5px 15px rgba(0,0,0,0.3)",}}>
              <div style={{background:"rgb(236, 236, 236)"}}>
                <h2 style={{ margin:"0px",padding:"13px 0px" }}>Delete company</h2>
              </div>
              <div style={{border: "solid rgb(236, 236, 236) 1px", padding:"10px"}}>
                <p style={{ marginBottom: "20px" }}>Do you want to delete the company? <br/><br/>Note: The company will be deleted without the possibility of restoration.</p>
                <div className="submit-container" style={{padding:"0px 10px", margin: "20px 0px"}}>
                  <div className="cancel" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => setIsOpen(false)}>Cancel</div>
                  <div className="submit" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => okClick()}>Ok</div>
                </div>
              </div>
            </div>
        </div>
      )}
    </div>
  );
  }

  function navigateToCompanySettingsClick(id) {
    navigate("/company/" + id);
  }

  function deleteCompanyClick() {
    setIsOpen(true);
  } 

  async function okClick(id) {
    setLoading(true);
    let company = {
        companyId: selectedItemId
    };
    try {
       await infrastructureService.delete("Company", company);
       AppAlert.success("Company was deleted successfully");
    } catch (error) {
       AppAlert.error("Company deletion error");
    } finally {
        setLoading(false);
    }
    setCompanies([]);
    loadCompanies();
    loadStatisticSummary();
    setIsOpen(false);
  } 

const loadStatisticSummary = useCallback(async () => {
  try {
    setLoading(true);
     const data = await infrastructureService.get("Statistic"); 
     setAvailableCompanies(data.availableCompanies);
     setAvailableDevices(data.availableDevices);
     setAvailableUsers(data.availableUsers);
     setAvailableEmailNotifications(data.emailNotifications);
     setAvailablemMssagesNotifications(data.smsNotifications);
     setAvailablePhoneCallsNotifications(data.phoneCallsNotifications);
  } catch (error) {
     console.error("Error fetching statistic summary:", error);
  } finally {
    setLoading(false);
  }
}, [infrastructureService]);

const loadCompanies = useCallback(async () => {
  try {
    setLoading(true);
    let getCompanies = {
      filter: filter,
      showBlocked: showBlocked,
      fromIndex: (currentPage - 1) * itemsPerPage,
      itemsCount: itemsPerPage
    };
     const data = await infrastructureService.get("Companies", getCompanies); 
     setCompanies(data.items);
     setTotalPages(Math.ceil(data.totalItemsCount / itemsPerPage));
  } catch (error) {
     console.error("Error fetching companies:", error);
  } finally {
    setLoading(false);
  }
}, [infrastructureService, filter, showBlocked, currentPage, itemsPerPage]);

useEffect(() => {
  loadStatisticSummary();
}, [loadStatisticSummary]);

useEffect(() => {
    loadCompanies();
}, [loadCompanies]);

useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    };
    
    handleResize();
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
}, []); 

  const getPages = () => {
    const pages = [];
    const delta = 1; 
  
    for (let i = 1; i <= Math.min(2, totalPages); i++) {
      pages.push(i);
    }
  
    const start = Math.max(currentPage - delta, 3);
    const end = Math.min(currentPage + delta, totalPages - 2);

    if (start > 3) pages.push("left-ellipsis");

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 2) pages.push("right-ellipsis");

    if (totalPages > 3) {
      for (let i = Math.max(totalPages - 1, end + 1); i <= totalPages; i++) {
        pages.push(i);
      }
    }

    return [...new Set(pages)]; 
  }

  return (
    <div>
      <div className="div-menu">
        <div onClick={() => setOpen(true)} className="menu-button">
          <label><svg width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 
                                         0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
          </svg></label>
        </div>
        {open && (
          <div className="modal">
             <div className="modal-content">
               <div className="col-span-12 h-full rounded-2xl bg-white/70 p-4 shadow-sm ring-1 ring-gray-100 md:col-span-3 lg:col-span-2 modal-content-div">
                <div className="close-modal" onClick={() => setOpen(false)}>
                  <MenuIcon/>
                </div>
                <div className="space-y-6">
                  <div>
                      <p className="px-2 text-sm font-semibold text-gray-600">Overview</p>
                      <div className="mt-2 space-y-1">
                         <Link className="link-item-selected" to="/">
                           <label className="link-lab"> 
                              <CompaniesMenuIcon/> Companies
                              <label className="label-float-end">{availableCompanies}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/users">
                           <label className="link-lab">
                              <UsersMenuIcon/> Users
                              <label className="label-float-end">{availableUsers}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/devices">
                           <label className="link-lab">
                               <DevicesMenuIcon/> Devices
                               <label className="label-float-end">{availableDevices}</label>
                           </label>
                         </Link>
                      </div>
                      <hr/>
                  </div>
                  
                   <div className="pt-2">
                        <p className="px-2 text-sm font-semibold text-gray-600">Notifications</p>
                        <div className="mt-2 space-y-1">
                         <Link className="link-item" to="/emails">
                           <label className="link-lab">
                              <EmailsMenuIcon/> Emails
                               <label className="label-float-end">{emailNotifications}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/messages">
                           <label className="link-lab">
                              <MessagesMenuIcon/> Messages
                              <label className="label-float-end">{messagesNotifications}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/phoneCalls">
                           <label className="link-lab">
                              <PhoneNumberMenuIcon/> Phone Calls
                              <label className="label-float-end">{phoneCallsNotifications}</label>
                           </label>
                         </Link>
                        </div>
                        <hr/>
                    </div>
                    
                  <div className="mx-2 h-px bg-gray-200"/></div>
                </div>
             </div>
          </div>
        )}
      </div>
       <div className='companies'>
          <div className='filter-c'>
             <div>
               <div className='div-input-filter-c'>
                <div className="group">
                    <svg className="icon" aria-hidden="true" viewBox="0 0 16 16">
                         <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 
                         1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                    </svg>
                    <input placeholder="Filter by keywords" type="search" className="input-filter" onChange={handleChange} onBlur={handleBlur} value={filter}/>
                </div>
               </div>
                {(userRole !== undefined && userRole === Global_Admin_Role) ? (
                  <svg className="icon-add" aria-hidden="true" viewBox="0 0 16 16" onClick={() => navigateToCompanySettingsClick("new")}>
                    <path d="M8 1a.5.5 0 0 1 .5.5V7.5H14a.5.5 0 0 1 0 1H8.5V14a.5.5 0 0 1-1 0V8.5H2a.5.5 0 0 1 0-1h5.5V1.5A.5.5 0 0 1 8 1Z" />
                  </svg>
                ) : (<div className="icon-add"></div>)}
             </div>
             <div className='div-input-checkbox-c'>
                <div className="checkbox-c">
                  <div className="toggle-switch">
                     <input className="toggle-input" id="toggle" type="checkbox" onChange={handleShowBlockedChange} checked={showBlocked}/>
                     <label className="toggle-label" htmlFor="toggle"></label>
                     <span className="toggle-label-text">Show suspended</span>
                  </div> 
                </div>
             </div>
          </div>

          {loading && (<div>Loading...</div>)}
                
          <div className="pagination-div pagination-div-margin">
                <nav aria-label="pagination">
                   <ul className="pagination">
                    <li>
                      <button disabled={currentPage === 1} onClick={() => handlePageChange(1)}
                          style={{padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                  color: "#333", fontWeight: "normal", backgroundColor: currentPage === 1 ? "#e6e6e6ff" : "white" }}>
                         &laquo;
                      </button>
                    </li>
                    {getPages().map((page, index) => page === "left-ellipsis" || page === "right-ellipsis" ? (
                        <li key={index}>…</li>) : (<li key={index}>
                          <button onClick={() => handlePageChange(page)}
                            style={{ margin: "0", padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                     backgroundColor: currentPage === page ? "#333" : "white", color: currentPage === page ? "white" : "#333", 
                                     fontWeight: currentPage === page ? "bold" : "normal", cursor: "pointer"}}>
                            {page}
                          </button>
                        </li>
                     ))}
                     <li>
                      <button disabled={currentPage === totalPages} onClick={() => handlePageChange(totalPages)}
                           style={{padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                   color: "#333", fontWeight: "normal", backgroundColor: currentPage === totalPages ? "#e6e6e6ff" : "white" }}>
                        &raquo;
                      </button>
                    </li>
                   </ul>
                </nav>
               </div>

         {!loading && (<div className="card-list">
            {companies != null && companies.length > 0 ? (companies.map((card) => (
              <Card key={card.id} id={card.id} name={card.name} email={card.email} site={card.webSite} activeAlarmCount={card.activeAlarmCount}
                    availableDevices={card.availableDevices} availableUsers={card.availableUsers}/>))) : (
              <p>No companies available.</p>
            )}
         </div>)}

       </div>
    </div>
  );
}

export default Companies;